// extracted by mini-css-extract-plugin
export default {"root":"ConnectDataText_root__Qyn1r","text":"ConnectDataText_text__ln0kV"};